import userService from '../../services/user.service';
import {
  APPLICATION_REFRESH_DATE,
  APP_IS_READY,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  INITIAL_STATE,
  LABELS_USE_CACHE,
} from '../actions';
import { getLabels } from '../actions/labels.actions';

export const labelsCacheMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    next(action);

    if (action.type === INITIAL_STATE) {
      const { labels } = getState();
      const hasCachedData = labels.list?.length > 0;

      if (hasCachedData) {
        dispatch({ type: LABELS_USE_CACHE });
      }
    }
  };

export const labelsFetchDataMiddleware =
  ({ dispatch, getState }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_IS_READY ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(getLabels());
    }
  };

export const labelsMiddleware = [labelsCacheMiddleware, labelsFetchDataMiddleware];
